export default __webpack_public_path__ + "static/q_karma-635f9e12877f1713de08d05c8e498eca.png";